/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'

const Body = styled.div`
  border-top: 2px solid #000;
  width: 100%;
  padding: 30px 15px;
  margin: 0 auto;
  word-break: break-word;

  @media (min-width: ${props => props.theme.responsive.medium}) {
    padding: 30px 60px;
  }
  

  h1,
  h2,
  h3 {
    font-weight: 600;
    line-height: 1.25;
    margin: 0 0 1rem 0;
  }

  h1 {
    font-size: 1.5em;
  }
  h2 {
    font-size: 1.25em;
  }
  h3 {
    font-size: 1em;
  }

  p {
    line-height: 1.6;
    margin: 0 0 1em 0;
    white-space: pre-wrap;
  }

  a {
    transition: 0.2s;
    color: ${props => props.theme.colors.text};
  }

  del {
    text-decoration: line-through;
  }
  strong {
    font-weight: 600;
  }
  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 0 0 2em 0;
  }

  ul {
    li {
      list-style: disc;
      list-style-position: inside;
      line-height: 1.25;
      &:last-child {
        margin: 0;
      }
    }
  }

  ol {
    li {
      list-style: decimal;
      list-style-position: inside;
      line-height: 1.25;
      &:last-child {
        margin: 0;
      }
    }
  }

  hr {
    border-style: solid;
    border-color: ${props => props.theme.colors.green};
    margin: 0 0 2em 0;
  }

  blockquote {
    font-style: italic;
    border-left: 4px solid ${props => props.theme.colors.green};
    padding: 0 0 0 0.5em;
  }

  pre {
    margin: 0 0 2em 0;
    border-radius: 2px;
    background: ${props => props.theme.colors.green} !important;
    span {
      background: inherit !important;
    }
  }

  .gatsby-image-wrapper{
    margin-top: ${props => props.theme.space[2]}px;
    margin-bottom: ${props => props.theme.space[2]}px;
  }
`

const PageBody = props => {
  return <Body {...props}>{props.children}</Body>
}

export default PageBody
